import { number, object, string } from "yup";
import { decryptFromStorage, encryptForStorage } from "~/lib/crypto";
import { BusinessLogicError } from "~/lib/errors/businessLogicError";
import { isEmpty, isNil } from "~/lib/lodash";
import type { YupOutputType } from "~/lib/utils";

export const InvitationTokenSchema = object({
  companyId: number().required(),
  companyName: string().required(),
});

export type InvitationToken = YupOutputType<typeof InvitationTokenSchema>;

export const makeInvitationToken = (payload: InvitationToken) => {
  return encryptForStorage(JSON.stringify(payload));
};

export const parseInvitationToken = (token: string | null | undefined) => {
  if (isNil(token)) {
    return null;
  }

  if (isEmpty(token)) {
    return null;
  }

  try {
    const tmpToken = JSON.parse(decryptFromStorage(token));
    return InvitationTokenSchema.validateSync(tmpToken, { abortEarly: false });
  } catch (baseError) {
    throw new BusinessLogicError("Failed to parse invitation token")
      .fromError(baseError)
      .withErrorCode("F101")
      .withMetadata({ token });
  }
};
